import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from "classnames";
import { useState } from "react";
const SitemapItem = ({ item: sitemapItem, isRoot }) => {
    const [collapse, setCollapse] = useState(false);
    const hasItems = !!sitemapItem.items && !!sitemapItem.items.length;
    return (_jsx("ul", { className: cn({
            "rich-text__unordered-list": isRoot,
            "sitemap__item--parent": isRoot && hasItems,
            "sitemap__item--active": !collapse && isRoot && hasItems
        }, "sitemap__item break-inside-avoid"), onClick: () => setCollapse((prevState) => (isRoot ? !prevState : false)), children: _jsxs("li", { children: [sitemapItem.link ? (_jsx("a", { href: sitemapItem.link, onClick: (e) => e.stopPropagation(), children: sitemapItem.title })) : (_jsx("p", { children: sitemapItem.title })), !collapse && hasItems && sitemapItem.items.map((nestedItem) => _jsx(SitemapItem, { item: nestedItem, isRoot: false }))] }) }));
};
const Sitemap = (props) => {
    const { data } = props;
    return (_jsx("section", { className: "sitemap__section", children: _jsx("div", { className: "sitemap__container section-container--md rich-text__wrapper", children: data.map((item, index) => (_jsx(SitemapItem, { item: item, isRoot: true }, `${index}-${item.title}`))) }) }));
};
export default Sitemap;
